<script>
  import Link from "../Types/Link.svelte";
  export let fab_item = {};
  export let classNames = "";
  let { product } = fab_item.third_party_data;
</script>

<Link {fab_item} {classNames}>
  <div slot="icon">
    <img width="40" src={product.image} alt={product.name} />
  </div>

  <div slot="label">
    <div>
      <p style="margin-bottom:5px">
        {product.post_title}
      </p>
      <div>
        {#if product.sale_price}
          <span style="text-decoration: line-through;">
            {@html product.regular_price_formatted}
          </span>
          <span style="font-weight: bold; margin-left: 8px;">
            {@html product.sale_price_formatted}
          </span>
        {:else}
          <span>
            {@html product.regular_price_formatted}
          </span>
        {/if}
      </div>
    </div>
  </div>
</Link>
